import React from 'react';

const Section5FamilyDetails = ({ formData, handleChange }) => (
    <div className="fade-in">
        <h4 className="mb-3">5. Family Details</h4>
        <div className="row">
            <div className="col-md-6 mb-3">
                <label className="form-label">Father’s Name</label>
                <input type="text" name="fatherName" value={formData.fatherName} onChange={handleChange} className="form-control" />
            </div>
            <div className="col-md-6 mb-3">
                <label className="form-label">Father’s Occupation</label>
                <input type="text" name="fatherOccupation" value={formData.fatherOccupation} onChange={handleChange} className="form-control" />
            </div>
        </div>
        <div className="row">
            <div className="col-md-6 mb-3">
                <label className="form-label">Mother’s Name</label>
                <input type="text" name="motherName" value={formData.motherName} onChange={handleChange} className="form-control" />
            </div>
            <div className="col-md-6 mb-3">
                <label className="form-label">Mother’s Occupation</label>
                <input type="text" name="motherOccupation" value={formData.motherOccupation} onChange={handleChange} className="form-control" />
            </div>
        </div>
        <div className="row">
            <div className="col-md-6 mb-3">
                <label className="form-label">Number of Brothers</label>
                <input type="number" name="brothers" value={formData.brothers} onChange={handleChange} className="form-control" />
            </div>
            <div className="col-md-6 mb-3">
                <label className="form-label">Number of Sisters</label>
                <input type="number" name="sisters" value={formData.sisters} onChange={handleChange} className="form-control" />
            </div>
        </div>
         <div className="mb-3">
            <label className="form-label">Current Residence <span className="text-danger">*</span></label>
            <input type="text" name="currentResidence" value={formData.currentResidence} onChange={handleChange} className="form-control" required placeholder="e.g., Pune, Maharashtra" />
        </div>
    </div>
);

export default Section5FamilyDetails;